<ng-container [ngSwitch]="reviewSyncState$ | async">
  <span *ngSwitchCase="CollabSessionSyncState.SaveFailed" class="mc-toolbar-text mc-flare-file-reviewer-toolbar-content-text">
    Changes not Saved
  </span>
  <span *ngSwitchCase="CollabSessionSyncState.Saved" class="mc-toolbar-text mc-flare-file-reviewer-toolbar-content-text">
    Saved
    <span class="mc-toolbar-spacer"></span>
    <mat-icon fontSet="project-titan" fontIcon="icon-checkmark" class="mc-centered-text-icon"></mat-icon>
  </span>
  <span *ngSwitchCase="CollabSessionSyncState.Saving" class="mc-toolbar-text mc-flare-file-reviewer-toolbar-content-text">
    Saving...
  </span>
  <span *ngSwitchCase="CollabSessionSyncState.Unsaved" class="mc-toolbar-text mc-flare-file-reviewer-toolbar-content-text">
    Saving...
  </span>
  <span *ngSwitchCase="CollabSessionSyncState.Reverting" class="mc-toolbar-text mc-flare-file-reviewer-toolbar-content-text">
    Reverting...
  </span>
  <span *ngSwitchCase="CollabSessionSyncState.Reverted" class="mc-toolbar-text mc-flare-file-reviewer-toolbar-content-text">
    Reverted
  </span>
  <span *ngSwitchCase="CollabSessionSyncState.RevertFailed" class="mc-toolbar-text mc-flare-file-reviewer-toolbar-content-text">
    Failed to Revert Document
  </span>
</ng-container>

<ng-container *ngIf="reviewFileUser">
  <button *ngIf="reviewFile?.Status === ReviewFileStatus.Open && reviewFileUser.Status !== ReviewFileUserStatus.Submitted" [disabled]="submitDisabled$ | async" mat-flat-button color="primary" class="mc-flare-file-reviewer-toolbar-content-status mc-flare-file-reviewer-toolbar-content-submit-button" (click)="onSubmitClicked()">
    <ng-container *ngIf="submitting; else submit">Submitting</ng-container>
    <ng-template #submit>Submit</ng-template>
  </button>
  <span *ngIf="reviewFile?.Status === ReviewFileStatus.Open && reviewFileUser.Status === ReviewFileUserStatus.Submitted" class="mc-toolbar-text mc-flare-file-reviewer-toolbar-content-text">Submitted</span>
</ng-container>

<span *ngIf="reviewFile?.Status === ReviewFileStatus.Closed || reviewFile?.Status === ReviewFileStatus.Accepted" class="mc-toolbar-text mc-flare-file-reviewer-toolbar-content-text">Read-Only</span>